<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Academic Year</h2>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                <PrimeButton
                    label="Fall Semester"
                    icon="pi-file-o"
                    class="p-button-rounded p-button-text"
                    @click="action(slotProps.data, 'Fall')"
                />
                <PrimeButton
                    label="Spring Semester"
                    icon="pi-file-o"
                    class="p-button-rounded p-button-text"
                    @click="action(slotProps.data, 'Spring')"
                />
                <PrimeButton
                    label="Summer Semester"
                    icon="pi-file-o"
                    class="p-button-rounded p-button-text"
                    @click="action(slotProps.data, 'Summer')"
                />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRouter, useRoute } from "vue-router";

export default {
    name:"AcademicResults",
    setup(){
        const route = useRoute();
        const router = useRouter();
        const id = computed(() => route.params.id)
        const state=reactive({loading:true})
        const list = ref([])
        const globalFilter=ref("")
        onMounted(() => {
            call({
                url:urls.academic,
                data:{viewAcademicYear:id.value},
                success:(res)=>{
                state.loading=false
                if(res.status){
                    if (!Array.isArray(res.msg)) {
                        list.value = Object.values(res.msg)
                    } else {
                        list.value = res.msg
                    }
                }else{
                    alert(res.msg);
                }
                }
            })
        });

        function action(row,type){
            console.log(type, row)
            router.push({ name: 'resultsview', query: { year: id.value, stu: row.id, s:type } });
        }
        
        return {list,globalFilter, state,action}
    }
}
</script>